// eslint-disable-next-line
// @ts-nocheck
import '../../NavigationPanel/NavigationPanel';
import './headerTabs';
import { favorites } from 'store';
import mainPageEventHandlers from './mainPageEventHandlers';
import MainWindowCuiLayout from '../../mainWindowCuiLayout/MainWindowCuiLayout';
import TocEditorCuiLayout from '../../mainWindowCuiLayout/TocEditor/TocEditorCuiLayout';
import UserNotificationsContainer from './userNotifications';
import notCertifiedBrowser from './notCertifiedBrowser';
import deepLinking from './deepLinking';

window.favorites = favorites;
window.MainWindowCuiLayout = MainWindowCuiLayout;
window.UserNotificationContainer = UserNotificationsContainer;
window.deepLinking = deepLinking;

export {
	deepLinking,
	mainPageEventHandlers,
	MainWindowCuiLayout,
	TocEditorCuiLayout,
	UserNotificationsContainer,
	notCertifiedBrowser
};
